import ActionTypes from "../constants/action_types";

export default function clearTopic(organisationId, projectId) {
  return {
    type: ActionTypes.PROJECT_CLEAR.SUCCESS,
    organisation_id: organisationId,
    project_id: projectId,
  };
}
